import {
  ControlledCheckbox,
  ControlledTextField
} from 'components/shared/ControlledFields';
import { FormFieldsWrapper } from 'components/shared/AdminSettings/FormFieldsWrapper';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useHandleValidSettings } from './hooks/useHandleValidSettings';
import { WarningTooltip } from 'components/shared/WarningTooltip';

export const SMSFields = () => {
  const { t: tMailSMS } = useTranslation('common', {
    keyPrefix: 'mailAndSMS'
  });
  const { t } = useTranslation('common', {
    keyPrefix: 'mailAndSMS.smsSection.form'
  });
  const methods = useFormContext();
  const { control } = methods;
  const isValid = useHandleValidSettings(methods, 'sms.valid', 'sms.active');

  return (
    <FormFieldsWrapper noPadding>
      <WarningTooltip
        title={tMailSMS('incompleteMessage')}
        isVisible={isValid === false}
      >
        <ControlledCheckbox
          disabled={isValid === false}
          control={control}
          name="sms.active"
          label={t('active')}
        />
      </WarningTooltip>
      <ControlledTextField
        control={control}
        name="sms.sms_application_name"
        label={t('application_name')}
      />
      <ControlledTextField
        type="number"
        control={control}
        name="sms.sms_max_length"
        label={t('maxLength')}
      />
      <ControlledTextField
        control={control}
        name="sms.sms_sender_address"
        label={t('senderAddress')}
      />
    </FormFieldsWrapper>
  );
};
